import {getUserCountry} from "@global/utilities/global-country-data.js";
import {getInitialRadius} from "@global/global-elements/global-dealer-search/utilities.js";

if (!(window.DEALER_SEARCH_DATA && window.DEALER_SEARCH_DATA.dealers && window.DEALER_SEARCH_DATA.dealerTypes)) {
    console.error('dealer search data not set.')
}

let initialCenter = { lat: 49.2621726 , lng: 11.4520158 };
let initialZoom = 8;

if (window.DEALER_SEARCH_MODE === 'duropal') {
    window.DEALER_SEARCH_DATA.dealers = window.DEALER_SEARCH_DATA.dealers.filter(dealer => dealer.country === 'GB' || dealer.country === 'IE');
    window.DEALER_SEARCH_DATA.dealerTypes = window.DEALER_SEARCH_DATA.dealerTypes.filter(type => type.identifier === 'compactWorktop' || type.identifier === 'worktop');
    initialCenter = {lat: 54.1800227, lng: -3.9072231}
    initialZoom = 6
}

export default {
    // Parameter
    requireEmail: false,
    // Karten-Darstellung
    mapCenter: initialCenter,
    zoom: initialZoom,
    userLocation: null,
    // Händlerdaten
    dealerData: window.DEALER_SEARCH_DATA || { dealers: [], dealerTypes: [] },
    dealerResults: null,
    // Form-Felder
    country: getUserCountry(),
    city: null,
    radius: getInitialRadius(),
    // Cache? :-)
    availableFilters: [], // Abhängig vom Land und vorhandenen Daten
};
